import { Path, Svg, SvgProps } from 'react-native-svg';

// The 3PMSF winter-tire sidewall mark, normalized to 24x24 to match Lucide sizing
const ThreePeakMountainSnowflake = ({ color, ...props }: SvgProps) => (
  <Svg viewBox='0 0 24 24' fill='none' {...props}>
    <Path
      d='M2.75 21.18L7.86 9.97L9.39 11.5L12.93 2.75L15.09 10.3L17.21 7.85L21.25 21.18Z'
      stroke={color}
      strokeWidth='1.1'
      strokeLinejoin='miter'
    />
    <Path
      d='M13 12.45V18.96M10.19 14.08L15.81 17.32M10.19 17.32L15.81 14.08M12.35 13.14L13 13.79L13.64 13.14M12.35 18.26L13 17.61L13.64 18.26M11.11 13.82L11.34 14.71L10.47 14.98M14.89 13.82L14.66 14.71L15.53 14.98M11.11 17.73L11.34 16.69L10.47 16.42M14.89 17.73L14.66 16.69L15.53 16.42'
      stroke={color}
      strokeWidth='1'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Svg>
);

export { ThreePeakMountainSnowflake };
